import gql from "graphql-tag";

// fragment
export const INVENTORY_CHANGE_REASON_TAG_FRAGMENT = gql`
    fragment inventoryChangeReasonTag on InventoryChangeReasonTagNode {
        id
        changeReason
        tag
        updatedAt
        updatedBy
    }
`;

// all query
export const INVENTORY_CHANGE_REASON_TAGS_QUERY = gql`
    query {
        tenantInventoryChangeReasonTags {
            edges {
                node {
                    ...inventoryChangeReasonTag
                }
            }
        }
    }
    ${INVENTORY_CHANGE_REASON_TAG_FRAGMENT}
`;

// single query
export const SINGLE_INVENTORY_CHANGE_REASON_TAG_QUERY = gql`
    query inventoryChangeReasonTag($id: ID!) {
        inventoryChangeReasonTag(id: $id) {
            ...inventoryChangeReasonTag
        }
    }
    ${INVENTORY_CHANGE_REASON_TAG_FRAGMENT}
`;

// create
export const CREATE_INVENTORY_CHANGE_REASON_TAG_MUTATION = gql`
    mutation createInventoryChangeReasonTag(
        $input: CreateInventoryChangeReasonTagInput!
    ) {
        createInventoryChangeReasonTag(input: $input) {
            inventoryChangeReasonTag {
                ...inventoryChangeReasonTag
            }
        }
    }
    ${INVENTORY_CHANGE_REASON_TAG_FRAGMENT}
`;

// update
export const UPDATE_INVENTORY_CHANGE_REASON_TAG_MUTATION = gql`
    mutation updateInventoryChangeReasonTag(
        $input: UpdateInventoryChangeReasonTagInput!
    ) {
        updateInventoryChangeReasonTag(input: $input) {
            inventoryChangeReasonTag {
                ...inventoryChangeReasonTag
            }
        }
    }
    ${INVENTORY_CHANGE_REASON_TAG_FRAGMENT}
`;

// delete
export const DELETE_INVENTORY_CHANGE_REASON_TAG_MUTATION = gql`
    mutation deleteInventoryChangeReasonTag(
        $input: DeleteInventoryChangeReasonTagInput!
    ) {
        deleteInventoryChangeReasonTag(input: $input) {
            inventoryChangeReasonTag {
                ...inventoryChangeReasonTag
            }
        }
    }
    ${INVENTORY_CHANGE_REASON_TAG_FRAGMENT}
`;
